import React from "react";
import SelectDynoType from "./selectDynoType";
import { Box, Heading, Text } from "@chakra-ui/react";
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { useCreateNewDyno } from "./useCreateNewDyno"
import { CreateNewAIDynoWithTemplatePage } from "../CreateNewAIDynoWithTemplatePage";
import { HelmetComponent } from "../../components/HelmetComponent";

export const CreateNewDynoPage = () => {

  const {
    selectDynoType,
    dynoTypes,
    selectedDynoType,
    loading,
    user,
    publisher
  } = useCreateNewDyno();

  return (
    <>
      <HelmetComponent title={`Create EdDoc - Home - ${user.firstName} ${user.lastName}`} />
      {loading && <LoadingOverlay />}
      <Text fontSize="xl" fontWeight={600}>Select Content Type</Text>
      <Text fontSize="md" color="gray.600">Choose the type of content you want to create for your EdDoc</Text>
      <Box bg="gray.100" p={6} borderRadius="lg" mt={5} mb={5}>
        <Text fontSize="xl" color="blue.700">What is EdDoc?</Text>
        <Text mt={2} fontSize="sm" color="gray.600">
          EdDoc is a powerful educational resource that enables interactive learning. Build rich content with quizzes, multimedia, and real-time feedback. Seamlessly compile EdDocs into Courses and Books to create engaging, structured, and adaptive learning experiences.
        </Text>
      </Box>
      <Box>
        <Box background="white" padding="30px" boxShadow="lg" marginBottom="30px" borderRadius="20px">
          <Text>1. What would you like to create?</Text>
          <SelectDynoType
            selectDynoType={selectDynoType}
            selectedDynoType={selectedDynoType}
            dynoTypes={dynoTypes}
            isPro={publisher.isPro}
          />
        </Box>
        <CreateNewAIDynoWithTemplatePage selectedDynoType={selectedDynoType} />
      </Box>
    </>
  );
};
